import axiosInstance from '../Api/axiosInstance';

// Create a new domain
export const createDomain = (domainData, companyId) =>
	axiosInstance.post('/domains', domainData, {
		headers: { 'X-Company-ID': companyId },
	});

// Get all domains for a specific company
export const getDomains = (companyId) =>
	axiosInstance.get(`/domains/${companyId}/domains`);

// Get a single domain by ID
export const getDomainById = (domainId, companyId) =>
	axiosInstance.get(`/domains/${domainId}`, {
		headers: { 'X-Company-ID': companyId },
	});

// Trigger DNS verification for a domain
export const triggerDnsVerification = (sendGridDomainId, companyId) =>
	axiosInstance.post(
		`/domains/${sendGridDomainId}/trigger-verify`,
		{},
		{ headers: { 'X-Company-ID': companyId } },
	);

// Delete a domain
export const deleteDomain = (domainId, companyId) =>
	axiosInstance.delete(`/domains/${domainId}`, {
		headers: { 'X-Company-ID': companyId },
	});
